import {
    Blog,
    Brazebanner,
    CalloutTiles,
    CategoryTile,
    CategoryProductTile,
    CountDownTimer,
    GiftGuide,
    HeroBanner,
    ImageWithText,
    ImageWithTextWithOutOverlay,
    ImageTile,
    ImageTileWithOverlay,
    ImageWithLink,
    JoinPremiumAndPurchases,
    LoaltyProgram,
    MultiImagesContainer,
    PercentageTile,
    ProductTile,
    RichTextBox,
    ShopBySeries,
    TextTileWithPowerReviews,
    VerticalImageStack,
    VideoWithTextBanner,
    HeadLineBanner,
    MainBanner,
    PromotionalContentTileBanner,
    PopularCategory,
    Divider,
    LinkBanner,
    ShopTheLookProductTile,
    RectanglePromoWithProductTile,
    PDPlusVideoComponent
} from './assets'

import {
    BannerCarousel,
    Carousel,
    MobileGrid1r1c,
    MobileGrid2r1c,
    MobileGrid2r2c,
    MobileGrid2r3c,
    MobileGrid3r1c,
    MobileGrid3r2c,
    PercentageLayout,
    PopularAnimeSlider,
    popularCategories,
    ProductCarousel,
    ShopBySeriesLayout,
    ShopTheLookLayout,
    ProductTilesCarousel,
    Column1
} from './layouts'
import {MoreImageAndText} from './components/advanced'
import {CategoryBanner, PLProductList, PDProductDetail} from './components/dynamic'
import {
    TextTileWithEinsteinCarousel,
    EinsteinCarouselCategory,
    EinsteinCarouselProduct,
    EinsteinCarousel
} from './einstein'
import {ThinkAnalytics} from './think-analytics'

export const PAGEDESIGNER_TO_COMPONENT = {
    'advanced.moreImageAndText': MoreImageAndText,
    'assets.categorytile': CategoryTile,
    'assets.imageTile': ImageWithText,
    'assets.percentageTile': PercentageTile,
    'commerce_assets.blog': Blog,
    'commerce_assets.brazebannerComponent': Brazebanner,
    'commerce_assets.calloutTiles': CalloutTiles,
    'commerce_assets.categoryProducts': CategoryProductTile,
    'commerce_assets.countdownTimer': CountDownTimer,
    'commerce_assets.editorialRichText': RichTextBox,
    'commerce_assets.giftGuide': GiftGuide,
    'commerce_assets.heroBanner': HeroBanner,
    'commerce_assets.imageAndText': ImageWithText,
    'commerce_assets.imageAndTextWithoutOverlay': ImageWithTextWithOutOverlay,
    'commerce_assets.imageTileWithOverlay': ImageTileWithOverlay,
    'commerce_assets.imageWithLink': ImageWithLink,
    'commerce_assets.joinPremiumAndPurchases': JoinPremiumAndPurchases,
    'commerce_assets.loyaltyProgram': LoaltyProgram,
    'commerce_assets.multiImagesContainer': MultiImagesContainer,
    'commerce_assets.photoTile': ImageTile,
    'commerce_assets.productTile': ProductTile,
    'commerce_assets.shopBySeries': ShopBySeries,
    'commerce_assets.textTileWithPowerReviews': TextTileWithPowerReviews,
    'commerce_assets.verticalImageStack': VerticalImageStack,
    'commerce_assets.videoWithTextBanner': VideoWithTextBanner,
    'commerce_layouts.bannerCarousel': BannerCarousel,
    'commerce_layouts.carousel': Carousel,
    'commerce_layouts.mobileGrid1r1c': MobileGrid1r1c,
    'commerce_layouts.mobileGrid2r1c': MobileGrid2r1c,
    'commerce_layouts.mobileGrid2r2c': MobileGrid2r2c,
    'commerce_layouts.mobileGrid2r3c': MobileGrid2r3c,
    'commerce_layouts.mobileGrid3r1c': MobileGrid3r1c,
    'commerce_layouts.mobileGrid3r2c': MobileGrid3r2c,
    'commerce_layouts.percentageOffers': PercentageLayout,
    'commerce_layouts.popularAnimeSlider': PopularAnimeSlider,
    'commerce_layouts.popularCategories': popularCategories,
    'commerce_layouts.productCarousel': ProductCarousel,
    'commerce_layouts.shopBySeriesComponent': ShopBySeriesLayout,
    'dynamic.dynamicCategoryBanner': CategoryBanner,
    'dynamic.productDetail': PDProductDetail,
    'dynamic.productList': PLProductList,
    'einstein.textTileWithEinsteinCarousel': TextTileWithEinsteinCarousel,
    'think_analytics.thinkAnalytics': ThinkAnalytics,
    'einstein.einsteinCarouselCategory': EinsteinCarouselCategory,
    'einstein.einsteinCarouselProduct': EinsteinCarouselProduct,
    'einstein.einsteinCarousel': EinsteinCarousel,
    'assets.headlinebanner': HeadLineBanner,
    'pd_assets.PDPlusVideoComponent': PDPlusVideoComponent,
    'commerce_assets.mainBanner': MainBanner,
    'commerce_assets.popularCategory': PopularCategory,
    'commerce_assets.productListTile': PromotionalContentTileBanner,
    'commerce_layouts.mobileGridLookBook': ShopTheLookLayout,
    'commerce_layouts.productTilesCarousel': ProductTilesCarousel,
    'layouts.1column': Column1,
    'advanced.divider': Divider,
    'dynamic.rectangularPromoWithProducts': RectanglePromoWithProductTile,
    'commerce_assets.category': LinkBanner,
    'commerce_assets.shopTheLook': ShopTheLookProductTile
}
